<script lang="ts" setup>
import PalkLogoColor from "@/components/PalkLogoColor.vue";
import LanguageSelection from "@/components/LanguageSelection.vue";
import LoginBanner from "@/features/login-banner/LoginBanner.vue";
import LoginForm from "@/_demo/LoginForm.vue";

defineOptions({
  name: 'SignIn',
})
</script>

<template>
  <div class="container">
    <div class="login-form">
      <palk-logo-color/>
      <h1>Login</h1>
      <language-selection/>
      <p>Please enter your credentials to log in.</p>
      <login-form/>
    </div>
    <div class="banner">
      <login-banner/>
    </div>
  </div>

</template>

<style scoped>

html, body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;

}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw; /* Add this */
  margin: 0; /* Add this */
  padding: 0; /* Add this */
  gap: 30px;
  background: #F4F5F9 url("@/assets/login-page-background.svg") no-repeat fixed center center;
}

.login-form, .banner {
  height: 590px;
  border: 1px solid #ccc;

}

.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.login-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 400px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

@media (max-width: 1100px) {
  .banner {
    display: none;
  }

  .container {
    gap: 0;
  }
}

</style>